import type { EdiAnchor } from "@/api/mapperApi";

const MONO = "var(--sapFontMonoFamily, monospace)";
const LABEL = "var(--sapContent_LabelColor)";
const BORDER = "var(--sapList_BorderColor)";

function Cell({ children, header }: { children: React.ReactNode; header?: boolean }) {
  return (
    <td
      style={{
        padding: "2px 8px",
        borderRight: `1px solid ${BORDER}`,
        fontFamily: header ? undefined : MONO,
        color: header ? LABEL : undefined,
        fontSize: header ? "0.7rem" : "0.78rem",
        textAlign: "left",
        whiteSpace: "nowrap",
      }}
    >
      {children}
    </td>
  );
}

export function EdiVerortung({
  anchor,
  align = "left",
}: {
  anchor: EdiAnchor;
  align?: "left" | "right";
}): JSX.Element {
  const showKomp = !!anchor.component;
  const dash = "—";

  const segName = anchor.seg_name || anchor.segment;
  const codes = anchor.value_pool ?? [];

  return (
    <div data-testid="edi-verortung" style={{ display: "inline-block", textAlign: align }}>
      <table
        style={{
          borderCollapse: "collapse",
          border: `1px solid ${BORDER}`,
          fontSize: "0.78rem",
          marginBottom: "4px",
        }}
      >
        <thead>
          <tr>
            <Cell header>SG</Cell>
            <Cell header>Seg</Cell>
            <Cell header>Qual</Cell>
            <Cell header>DE</Cell>
            {showKomp && <Cell header>Komp</Cell>}
          </tr>
        </thead>
        <tbody>
          <tr>
            <Cell>{anchor.segment_group || dash}</Cell>
            <Cell>{anchor.segment || dash}</Cell>
            <Cell>{anchor.qualifier || dash}</Cell>
            <Cell>{anchor.data_element || dash}</Cell>
            {showKomp && <Cell>{anchor.component}</Cell>}
          </tr>
        </tbody>
      </table>

      {anchor.seg_name && (
        <div style={{ fontWeight: 600, fontSize: "0.82rem", textAlign: align }}>{segName}</div>
      )}
      {anchor.de_name && (
        <div style={{ fontSize: "0.74rem", color: LABEL, textAlign: align }}>{anchor.de_name}</div>
      )}
      {anchor.example && (
        <div style={{ fontFamily: MONO, fontSize: "0.72rem", textAlign: align }}>
          Beispiel: {anchor.example}
        </div>
      )}
      {codes.length > 0 && (
        <div style={{ fontSize: "0.72rem", color: LABEL, textAlign: align }}>
          Codes: {codes.slice(0, 6).join(", ")}
          {codes.length > 6 ? ", …" : ""}
        </div>
      )}
    </div>
  );
}
